export default __webpack_public_path__ + "static/tad_mainshop_2-2126f09fe437cffb4421e34605a9aa84.jpeg";